module.exports = {"name":"Name","fruit":"Fruits | Fruit | Fruit"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/enus.json
// module id = 2275
// module chunks = 1612